import { render, staticRenderFns } from "./CancelSaveEdit.vue?vue&type=template&id=21043e8a&scoped=true&lang=pug&"
import script from "./CancelSaveEdit.vue?vue&type=script&lang=js&"
export * from "./CancelSaveEdit.vue?vue&type=script&lang=js&"
import style0 from "./CancelSaveEdit.vue?vue&type=style&index=0&id=21043e8a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21043e8a",
  null
  
)

export default component.exports